import React, {Component} from 'react';

import emailMobile from '../icons/email_mobile.png';
import phoneMobile from '../icons/phone_mobile.png';
import googleMapsMobile from '../icons/google_maps_mobile.png';
import galleryMobile from '../icons/gallery_mobile.png';
import emailDesk from '../icons/email_desk.png';
import phoneDesk from '../icons/phone_desk.png';
import googleMapsDesk from '../icons/google_maps_desk.png';
import galleryDesk from '../icons/gallery_desk.png';

let mapsLink = 'https://www.google.com/maps/place/Axel+Doehler+Photography/@33.7108146,-117.8707189,17z/data=!4m13!1m7!3m6!1s0x80dcd92d07d828a7:0xf78499a15ed51497!2s2700+S+Main+St,+Santa+Ana,+CA+92707!3b1!8m2!3d33.7108146!4d-117.8685249!3m4!1s0x80dcd92d07d991cf:0x4f611b326f312403!8m2!3d33.7108146!4d-117.8685249'

export default class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobile: false
    }

    this.openEmail = this.openEmail.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  componentDidMount() {
    this.props.toggleWork(false);
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    this.setState({mobile: window.innerWidth <= 768});
  }

  openEmail() {
    var email = 'axel@axeldohler.com';
    var subject = '';
    var emailBody = '';
    document.location =
      "mailto:"+ email +
      "?subject=" + subject+
      "&body=" + emailBody;
  }

  render() {
    return (
      this.state.mobile
      ?
      // mobile contact setup
      <div className='contact-container' id='scroll'>
        <div className='contact-row' id='contact-rows-top'>
          <p className='contact-info'>2700 South Main Street<br/>Studio C<br/> Santa Ana, CA 92705</p>
        </div>
        <div className='contact-row' id='contact-rows-top'>
          <img
            className='contact-hover-icon'
            src={googleMapsMobile}
            alt={'google maps icon'}
            onClick={() => window.open(mapsLink)}
          />
          {/* RE-ENABLE WHEN IMAGES UP
            <img
            className='contact-hover-icon'
            src={galleryMobile}
            alt={'gallery icon'}
            onClick={() => console.log('pics!')}
          />*/}
        </div>
        <div className='contact-line' id='contact-rows-top'></div>
        <div className='contact-row' id='contact-rows-top'>
          <p
            className='contact-info'
            id='contact-email'
            onClick={this.openEmail}
          >
            axel@axeldohler.com
          </p>
        </div>
        <div className='contact-row' id='contact-rows-top'>
          <img
            className='contact-hover-icon'
            src={emailMobile}
            alt={'email icon'}
            onClick={this.openEmail}
          />
        </div>
        <div className='contact-line' id='contact-rows-top'></div>
        <div className='contact-row'>
          <p>Studio:<br/>Mobile:</p>
          <p
            className='contact-info'
            id='contact-phone'
          >
            714-434-1173<br/>714-308-0024
          </p>
        </div>
        <div className='contact-row'>
          <img
            src={phoneMobile}
            alt={'phone icon'}
          />
        </div>
      </div>
      :
      // desktop contact setup
      <div className='contact-container' id='scroll'>
        <div className='contact-row' id='contact-rows-top'>
          <p className='contact-info'>2700 South Main Street<br/>Studio C<br/> Santa Ana, CA 92705</p>
          <img
            className='contact-hover-icon'
            src={googleMapsDesk}
            alt={'google maps icon'}
            onClick={() => window.open(mapsLink)}
          />
          {/* RE-ENABLE WHEN IMAGES UP <img
            className='contact-hover-icon'
            src={galleryDesk}
            alt={'gallery icon'}
            onClick={() => console.log('pics!')}
          />*/}
        </div>
        <div className='contact-line' id='contact-rows-top'></div>
        <div className='contact-row' id='contact-rows-top'>
          <p
            className='contact-info'
            id='contact-email'
            onClick={this.openEmail}
          >
            axel@axeldohler.com
          </p>
          <img
            className='contact-hover-icon'
            src={emailDesk}
            alt={'email icon'}
            onClick={this.openEmail}
          />
        </div>
        <div className='contact-line' id='contact-rows-top'></div>
        <div className='contact-row'>
          <p>Studio:<br/>Mobile:</p>
          <p
            className='contact-info'
            id='contact-phone'
          >
            714-434-1173<br/>714-308-0024
          </p>
          <img
            src={phoneDesk}
            alt={'phone icon'}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Contact.js